import { render, staticRenderFns } from "./AdvCartProductCustomizationDisplayValues.vue?vue&type=template&id=68538d49&scoped=true"
import script from "./AdvCartProductCustomizationDisplayValues.vue?vue&type=script&lang=js"
export * from "./AdvCartProductCustomizationDisplayValues.vue?vue&type=script&lang=js"
import style0 from "./AdvCartProductCustomizationDisplayValues.vue?vue&type=style&index=0&id=68538d49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68538d49",
  null
  
)

export default component.exports